import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class DevelopmentSubstance extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition,
        form: FormGroup,
        model: {},
    ) {
        super(form, 
            [...fieldDefinition.developmentSubstanceFields], model);

            
    }
}